const data = [
    {
        id: 1,
        image: './images/workimage/hiive.png',
        title:  'HIIVE Organization',
        desc: 'This is a website developed for an international organization',
        link: 'https://hakeemhkm.github.io/Hiive/'
    },
    {
        id: 2,
        image: './images/workimage/shop.png',
        title:  'E-Store Website',
        desc: 'This is an E-commerce website developed and designed',
        link: 'https://reliable-gaufre-759db9.netlify.app'
    },
    {
        id: 3,
        image: './images/workimage/crypto.png',
        title:  'Cryptocurrency App',
        desc: 'This is a Cryptocurrency app which shows the real coin price up & down',
        link: 'https://genuine-quokka-4ac600.netlify.app'
    },
    {
        id: 4,
        image: './images/workimage/movieapp.png',
        title:  'Movie App',
        desc: 'This is a Movie app, this app contains real time trending and upcoming movie from an api',
        link: 'https://relaxed-dieffenbachia-66abf5.netlify.app'
    },
    {
        id: 5,
        image: './images/workimage/larq.png',
        title:  'LARQ Website Clone',
        desc: 'This is a Larq website clone, included some new features',
        link: 'https://voluble-sfogliatella-3a1375.netlify.app'
    },
    {
        id: 6,
        image: './images/workimage/tailwind3.png',
        title:  'Designers App',
        desc: 'This is a Designers app developed using tailwind',
        link: 'https://ubiquitous-malabi-1e2e5a.netlify.app'
    },
]

export default data;